<template>
  <div class="newDataPage">
    <div class="steps">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="steps-content">
      <template v-if="current == 0">
        <new-customer @setFactory="setFactory" :customerInfo="customerInfo" ref="newCustomer"/>
      </template>
      <template v-if="current == 1">
        <new-feed-info 
          ref="newFeedInfo"
          @setFeedInfo="setFeedInfo" 
          :selectFactory="selectFactory" 
          :factoryId="factoryId"
          :feedInfoList="feedInfoList"
          :feedStageList="feedStageList"
          :ruminationLineFeedInfo="ruminationLineFeedInfo"
        />
      </template>
      <template v-if="current == 2">
        <new-customer-feedback 
          ref="newCustomerFeedback" 
          @setFeedBack="setFeedBack" 
          :ruminationLineFeedbackReq="ruminationLineFeedbackReq"
          @setFileList="setFileList"
          :fileListProp="{fileList,videoFileList}"
        />
      </template>
      <template v-if="current ==3">
        <new-finish 
          :returnList="returnList" 
          :saveSuccess="saveSuccess" 
          :recordId="recordId"
          @saveData="'saveData'"
        />
      </template>
    </div>
    <div class="footer">
      <a-button v-if="current > 0 && current < steps.length-1" @click="prev">上一步</a-button>
      <a-button v-if="current == 0" @click="returnList">取 消</a-button>
      <a-button v-if="current < steps.length - 2" type="primary" @click="next" style="margin-left: 10px">下一步</a-button>
      <a-button v-if="current == 2" type="primary" @click="next" style="margin-left: 10px">提 交</a-button>
    </div>
    <calculation-result-modal       
      :visible="visible" 
      @isShow="isShow"
      :calculationResult="calculationResult"
      :calculationAbnormal="calculationAbnormal"
      @calculationAbnormalInit="calculationAbnormalInit"
      @calculationConfirm="calculationConfirm"
    />
  </div>
</template>
<script>
import NewCustomer from './RuminateNewDataComponents/NewCustomer.vue';
import NewCustomerFeedback from './RuminateNewDataComponents/NewCustomerFeedback.vue';
import NewFeedInfo from './RuminateNewDataComponents/NewFeedInfo.vue';
import NewFinish from './RuminateNewDataComponents/NewFinish.vue';
import CalculationResultModal from './RuminateNewDataComponents/CalculationResultModal.vue'
import api from './api'
export default {
  components: { NewCustomer, NewFeedInfo, NewCustomerFeedback, NewFinish, CalculationResultModal},
  data() {
    return {
      current: 0,
      steps: [
        {title: '填写客户信息'},
        {title: '填写饲养信息'},
        {title: '填写客户反馈'},
        {title: '完成'},
      ],
      selectFactory:'',
      factoryId:'',
      customerInfo:{},
      feedInfoList:[{
        state: '开始',
        day: '',
        num:'',
        weight: '',
      },{
        state: '结束',
        day: '',
        num:'',
        weight: '',
      }],
      feedStageList:[],
      ruminationLineFeedbackReq:{},
      visible:false,
      ruminationLineFeedInfo:{},
      ruminationLineRaiseInfos:[],
      calculationResult:{},
      calculationAbnormal:[],
      settlementId:'',
      saveSuccess:false,
      recordId:'',
      fileList:[],
      videoFileList:[],
      Tipsmsg:''
    };
  },
  mounted(){
    if(this.$route.query.copyId) this.copyValues()
  },
  methods: {
    async copyValues(){
      let {copyId} = this.$route.query
      let params = {
        recordId: copyId,
        lineType: 'RUMINATION_LINE'
      }
      let res = await api.pigDetail(params)
      if(!res.success) this.$message.error(res.msg) 
      this.ruminationLineFeedInfo = res?.data?.ruminationLineFeedInfo || {}
      this.customerInfo = res?.data?.ruminationLineCustomerInfo || {}
      this.customerInfo.region = this.customerInfo.province&&this.customerInfo.city&&this.customerInfo.area ?
       [this.customerInfo.province,this.customerInfo.city,this.customerInfo.area] : undefined
      this.feedStageList = res?.data?.ruminationLineRaiseInfos || []
      if(!(this.customerInfo.createUser == window.localStorage.getItem('staffId')) && this.ruminationLineFeedInfo.feedBrand == '新希望'){
        this.ruminationLineFeedInfo.feedModel = ''
        this.ruminationLineFeedInfo.nhfFormulaId = ''
        this.ruminationLineFeedInfo.modelCode = ''
        this.ruminationLineFeedInfo.modelName = ''
      }
      this.calculationResult = res?.data?.calculationResult || {}
      this.ruminationLineFeedbackReq = res?.data?.ruminationLineFeedbackReq || {}
      this.loadFiles()
    },
    next() {
      if(this.current == 0){
        this.$refs.newCustomer.form.validateFields((err, values) => {
          if (!err) {
            this.customerInfo = values
            this.current++;
          }
        })
      }
      else if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          if (!err) {
            this.ruminationLineFeedInfo = values,
            this.$refs.newFeedInfo.sendData()
            this.feedCheck()
            if(this.Tipsmsg) this.$message.error(this.Tipsmsg)
            else this.getCalculationResult()
          }
        })
      }
      else if(this.current == 2){
        //保存数据
        this.$refs.newCustomerFeedback.form.validateFields((err) => {
          if (!err) {
            this.$refs.newCustomerFeedback.sendData()
            this.saveData()
          }
        })
        // this.current++;
      }
    },
    prev() {
      if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          this.ruminationLineFeedInfo = values,
          this.$refs.newFeedInfo.sendData()
        })
      }
      else if(this.current == 2){
        this.$refs.newCustomerFeedback.sendData()
      }
      this.current--;
    },
    setFeedInfo(value) {
      this.feedInfoList = value.feedInfoList
      this.feedStageList = value.feedStageList
      let into = this.feedInfoList[0]
      let out = this.feedInfoList[1]
      this.ruminationLineFeedInfo = {
        ...this.ruminationLineFeedInfo,
        nhfFormulaId:value.nhfFormulaId,
        modelName:value.modelName,
        modelCode:value.modelCode,
        proportionDiarrhea:value.proportionDiarrhea,
        intoDay:into.day,//.format('YYYY/MM/DD').replaceAll('/','-'),
        intoNum:into.num,
        avgInitialWeight:into.weight,
        outDay:out.day,//.format('YYYY/MM/DD').replaceAll('/','-'),
        avgEndWeight:out.weight,
        outNum:out.num
      }
      this.ruminationLineRaiseInfos = this.feedStageList
    },
    isShow(val){
      this.visible = val
    },
    setFactory(value) {
      this.factoryId = value.factoryId
      this.selectFactory = value.selectFactory
      this.settlementId = value.settlementId
      this.settlementName = value.settlementName
    },
    setFeedBack(value) {
      this.ruminationLineFeedbackReq = value
    },
    setFileList(value){
      this.fileList = value.fileList
      this.videoFileList =value.videoFileList
    },
    returnList(){
      this.$router.push({
        path: '/empirical-data/ruminate',
        query:{
          name: '反刍线路',
        }
      })
    },
    feedCheck(){
      this.Tipsmsg = ''
      if(!this.feedStageList.length) this.Tipsmsg = '请填写平均日饲喂情况'
      this.feedStageList.forEach(item=>{
        if(!item.weight || !item.price) this.Tipsmsg = '请完善原料信息'
      })
      this.feedInfoList.forEach((el) => {
        if(!el.day || !el.num || !el.weight) {
          this.Tipsmsg = '请完善出入栏信息'
        }
      })
    },
    async getCalculationResult(){
      const res = await this.$http.post("/sat-collect/ruminationLine/calculate", { 
        ruminationLineFeedInfo:this.ruminationLineFeedInfo,
        ruminationLineRaiseInfos:this.ruminationLineRaiseInfos
      })
      let { msg,success,data } = res;
      if(data) this.calculationResult = data 
      if(!success){
        this.visible = true
        this.calculationAbnormal = msg.split(",")
      }
      else this.visible = true
    },
    calculationConfirm(){
      this.current++;
    },
    calculationAbnormalInit(){
      this.calculationAbnormal = []
    },
    async saveData(){
      let params = {
        ruminationLineCustomerInfo:{
          ...this.customerInfo,
          province:this.customerInfo.region ? this.customerInfo.region[0] : undefined,
          city:this.customerInfo.region ? this.customerInfo.region[1] : undefined,
          area:this.customerInfo.region ? this.customerInfo.region[2] : undefined,
          factoryId:this.factoryId,
          settlementId:this.settlementId,
          settlementName:this.settlementName,
        },
        ruminationLineFeedInfo:this.ruminationLineFeedInfo,
        ruminationLineRaiseInfos:this.ruminationLineRaiseInfos.filter((item) => {
            return delete item.id 
        }),
        ruminationLineProductResult:this.calculationResult,
        ruminationLineFeedbackReq:this.ruminationLineFeedbackReq
      }
      const res = await this.$http.post("/sat-collect/ruminationLine/save", params)
      this.saveSuccess = res.success
      if(res.success) this.recordId = res.data.ruminationLineCustomerInfo.id
      this.current++
    },
    loadFiles() {
      this.fileList = []
      this.videoFileList = []
      this.ruminationLineFeedbackReq.uploadFiles?.forEach(item => {
        const fileName = item.fileName
        const arr = fileName.split("/")
        const name = arr[arr.length-1]
        this.$http.get('/sat-collect/upload/getFileUrlList',{ params:{fileName} }).then(res =>{
          if(item.mediaType == 'PIC'){
            this.fileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
          if(item.mediaType == 'VIDEO'){
            this.videoFileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
        })
      })
    }
  },
};
</script>

<style lang='scss'>
.newDataPage{
  background-color: #fff;
  margin-top: 20px;
  min-height: 90%;
  .ant-form-item-label{
    line-height: 20px;
  }
  .ant-form-explain{
    margin-top: -2px;
  }
}
.steps{
  padding: 30px;
}
.footer{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 8px;
  background: #fff;
  text-align: center;
  z-index: 1;
  .ant-btn{
    font-size: small !important
  }
}
</style>